import { Component, DestroyRef, Input, OnChanges, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CompanyService } from 'src/app/services/companies-services/company.service';
import { CompanyModel, UpdateCompanyModel } from 'src/app/models/company.model';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-companies-company-info-card',
    templateUrl: './companies-company-info-card.component.html',
    styleUrls: ['./companies-company-info-card.component.scss'],
    standalone: false
})
export class CompaniesCompanyInfoCardComponent implements OnInit, OnChanges {

  @Input() company: CompanyModel;

  userCreationFormErrorMessage: string;
  editCompanyForm = new UntypedFormGroup({
    active: new UntypedFormControl(null),
    companyInternalId: new UntypedFormControl(null, Validators.required),
    companyComercialName: new UntypedFormControl(null, Validators.required),
    companyCif: new UntypedFormControl({value: null, disabled: true}, Validators.required),
    companyFiscalName: new UntypedFormControl(null, Validators.required),
    companyAddress: new UntypedFormControl(null),
    companyCity: new UntypedFormControl(null),
    companyPostalCode: new UntypedFormControl(null),
    companyProvince: new UntypedFormControl(null),
    companyRegion: new UntypedFormControl(null),
    companyCountry: new UntypedFormControl(null, Validators.required),
    companyFax: new UntypedFormControl(null),
    companyPhone: new UntypedFormControl(null),
    companyWeb: new UntypedFormControl(null),
    companyEmail: new UntypedFormControl(null)
  });

  updateCompanySubscription: Subscription;

  constructor(
    private companyService: CompanyService,
    private destroyRef: DestroyRef
  ) { }

  ngOnInit() {}

  ngOnChanges() {
    if (this.company) {
      this.resetEditCompanyForm(this.company);
    }
  }

  private resetEditCompanyForm(data: CompanyModel) {
    this.editCompanyForm.patchValue({
      active: data.active,
      companyInternalId: data.internalId,
      companyComercialName: data.companyName,
      companyCif: data.companyCif,
      companyFiscalName: data.fiscalName,
      companyAddress: data.street,
      companyCity: data.city,
      companyPostalCode: data.zipCode,
      companyProvince: data.province,
      companyRegion: data.region,
      companyCountry: data.country,
      companyFax: data.faxNumber,
      companyPhone: data.phoneNumber,
      companyWeb: data.companyWeb,
      companyEmail: data.email
    });
  }

  public updateCompany() {
    const company: UpdateCompanyModel = {
      active: true,
      internalId: this.editCompanyForm.get('companyInternalId').value,
      companyName: this.editCompanyForm.get('companyComercialName').value,
      companyCif: this.editCompanyForm.get('companyCif').value,
      fiscalName: this.editCompanyForm.get('companyFiscalName').value,
      street: this.editCompanyForm.get('companyAddress').value,
      city: this.editCompanyForm.get('companyCity').value,
      zipCode: this.editCompanyForm.get('companyPostalCode').value,
      province: this.editCompanyForm.get('companyProvince').value,
      region: this.editCompanyForm.get('companyRegion').value,
      country: this.editCompanyForm.get('companyCountry').value,
      faxNumber: this.editCompanyForm.get('companyFax').value,
      phoneNumber: this.editCompanyForm.get('companyPhone').value,
      companyWeb: this.editCompanyForm.get('companyWeb').value,
      email: this.editCompanyForm.get('companyEmail').value
    };
    this.updateCompanySubscription = this.companyService.updateCompany(company).pipe(
      takeUntilDestroyed(this.destroyRef),
      tap(res => this.companyService.refreshCompany())
    ).subscribe();
  }

  public hasError(field) {
    const formControl = this.editCompanyForm.get(field);
    if (formControl.touched && formControl.invalid) {
      if (formControl.errors.required) {
        return '* Campo obligatorio';
      }
      return '* Campo ' + field + ' inválido';
    }
    return false;
  }
}
